export const appConfig = {
    BILLING_ADDRESS: process.env.REACT_APP_URL_BILLING,
    ROLLBAR_ACCESS_TOKEN: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
};
